import { Component, Input, forwardRef, EventEmitter, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as moment from 'moment';
import { Calendar } from 'primeng/calendar';

@Component({
    selector: 'max-calendar',
    templateUrl: './max-calendar.html',
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        multi: true,
        useExisting: forwardRef(() => CalendarComponent),
    }]
})
export class CalendarComponent implements ControlValueAccessor {
    @Input() defaultDate: Date;
    @Input() style: string;
    @Input() styleClass: string;
    @Input() inputStyle: string;
    @Input() inputId: string;
    @Input() name: string;
    @Input() inputStyleClass: string;
    @Input() placeholder: string;
    @Input() disabled: any;
    @Input() dateFormat = 'mm/dd/yy';
    @Input() inline = false;
    @Input() showOtherMonths = true;
    @Input() selectOtherMonths: boolean;
    @Input() showIcon: boolean;
    @Input() icon = 'pi pi-calendar';
    @Input() appendTo: any;
    @Input() readonlyInput: boolean;
    @Input() shortYearCutoff: any = '+10';
    @Input() monthNavigator: boolean;
    @Input() yearNavigator: boolean;
    @Input() yearRange: string;
    @Input() hourFormat = '24';
    @Input() showTime = false;
    @Input() timeOnly: boolean;
    @Input() stepHour = 1;
    @Input() stepMinute = 1;
    @Input() stepSecond = 1;
    @Input() showSeconds = false;
    @Input() required: boolean;
    @Input() showOnFocus = true;
    @Input() dataType = 'date';
    @Input() selectionMode = 'single';
    @Input() minDate: Date;
    @Input() maxDate: Date;
    @Input() maxDateCount: number;
    @Input() showButtonBar: boolean;
    @Input() todayButtonStyleClass = 'p-button-secondary';
    @Input() clearButtonStyleClass = 'p-button-secondary';
    @Input() autoZIndex = true;
    @Input() baseZIndex = 0;
    @Output() onFocus: EventEmitter<any> = new EventEmitter();
    @Output() onBlur: EventEmitter<any> = new EventEmitter();
    @Output() onClose: EventEmitter<any> = new EventEmitter();
    @Output() onSelect: EventEmitter<any> = new EventEmitter();
    @Output() onInput: EventEmitter<any> = new EventEmitter();
    @Output() onTodayClick: EventEmitter<any> = new EventEmitter();
    @Output() onClearClick: EventEmitter<any> = new EventEmitter();
    @Output() onMonthChange: EventEmitter<any> = new EventEmitter();

    @ViewChild(Calendar) calendarComponent: Calendar;

    public value: Date;
    public minJsDate: Date;
    public maxJsDate: Date;
    private onChangeHandler: (value: any) => void;
    private onTouchHandler: () => void;

    public ngOnChanges(changes: SimpleChanges): void {
        if ((null != changes.value) && (null != this.onChangeHandler)) {
            this.onChangeHandler(changes.value.currentValue);
        }

        if (null != changes.maxDate) {
            let momentDate = moment(changes.maxDate.currentValue);

            if (true == momentDate.isValid()) {
                this.maxJsDate = momentDate.toDate();
            } else {
                this.maxJsDate = null;
            }
        }

        if (null != changes.minDate) {
            let momentDate = moment(changes.minDate.currentValue);

            if (true == momentDate.isValid()) {
                this.minJsDate = momentDate.toDate();
            } else {
                this.minJsDate = null;
            }
        }
    }

    public blurEvent = (e: any): void => {
        if (null != this.onTouchHandler) {
            this.onTouchHandler();
        }

        this.onBlur.emit(e);
    };

    public writeValue = (obj: any): void => {
        let momentDate = moment(obj);

        if ((null == obj) || (false == momentDate.isValid())) {
            this.value = null;
            if (this.calendarComponent) {
                this.calendarComponent.onClearButtonClick(null);
            }
        } else {
            this.value = momentDate.toDate();
        }
    };

    public valueChanged = (v: any): void => {
        if (null != this.onChangeHandler) {
            this.onChangeHandler(v);
        }
    };

    public registerOnChange = (fn: any): void => {
        this.onChangeHandler = fn;
    };

    public registerOnTouched = (fn: any): void => {
        this.onTouchHandler = fn;
    };

    public setDisabledState ? = (isDisabled: boolean): void => {
        this.disabled = isDisabled;
    };
}
